export default {
  title: 'Alergeni',
  options: {
    dairy: 'Lactate/Lapte',
    eggs: 'Ouă',
    fish: 'Pește',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Arahide',
    sesame: 'Susan',
    shellfish: 'Fructe de mare',
    soy: 'Soia',
    tree_nuts: 'Fructe cu coajă lemnoasă',
    celery: 'Țelină',
    crustaceans: 'Crustacee',
    lupin: 'Lupin',
    molluscs: 'Moluște',
    mustard: 'Muștar',
    nuts: 'Nuci',
    sulphites: 'Sulfiți',
    almonds: 'Migdale',
    barley: 'Orz',
    brazil_nuts: 'Nuci de Brazilia',
    cashew: 'Caju',
    hazelnuts: 'Alune de pădure',
    kamut: 'Kamut',
    macadamia: 'Nuci macadamia',
    oats: 'Ovăz',
    pecan: 'Nuci pecan',
    pistachios: 'Fistic',
    rye: 'Secară',
    spelt: 'Alac',
    walnuts: 'Nuci',
    wheat: 'Grâu',
    sugared_drink: 'Băutură îndulcită',
    lentils: 'Linte',
    queensland_nuts: 'Nuci Queensland',
  },
};
